export default __webpack_public_path__ + "static/media/epigro_bg.6b023889.jpg";